import { render, staticRenderFns } from "./ChatTitleComponent.vue?vue&type=template&id=edcee6e2&scoped=true"
import script from "./ChatTitleComponent.vue?vue&type=script&lang=js"
export * from "./ChatTitleComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatTitleComponent.vue?vue&type=style&index=0&id=edcee6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcee6e2",
  null
  
)

export default component.exports